import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface DrillSheetProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  /** Tailwind max-width osztály asztali nézetre. */
  maxWidthClass?: string;
}

/**
 * Nagyobb ablak a gyakorlattárhoz: mobilon teljes képernyős, asztalon középre
 * igazított. Nem portálon renderel, így egy szülő párbeszédablakon belül is
 * használható (a headlessui a portált "kívülinek" tekintené).
 */
const DrillSheet: React.FC<DrillSheetProps> = ({ title, onClose, children, footer, maxWidthClass = 'md:max-w-2xl' }) => (
  <div className="fixed inset-0 z-50 flex items-stretch justify-center md:items-center md:p-4" role="dialog" aria-modal="true" aria-label={title}>
    <div className="absolute inset-0 bg-gray-900/50" onClick={onClose} />
    <div className={`relative flex w-full flex-col bg-white shadow-xl md:max-h-[90vh] md:rounded-lg ${maxWidthClass}`}>
      <div className="flex shrink-0 items-center justify-between gap-3 border-b border-gray-200 px-4 py-3 md:px-6">
        <h3 className="min-w-0 truncate text-lg font-semibold text-gray-900">{title}</h3>
        <button
          type="button"
          onClick={onClose}
          aria-label="Bezárás"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto p-4 md:p-6">{children}</div>
      {footer && <div className="shrink-0 border-t border-gray-200 px-4 py-3 pb-safe-4 md:px-6">{footer}</div>}
    </div>
  </div>
);

export default DrillSheet;
